/* Maratona Hero Slider - vanilla JS, no dependencies */
(function () {
  'use strict';

  function initSlider(root) {
    var slides = root.querySelectorAll('.maratona-hero__slide');
    if (slides.length <= 1) return;

    var dots = root.querySelectorAll('.maratona-hero__dot');
    var prevBtn = root.querySelector('.maratona-hero__arrow--prev');
    var nextBtn = root.querySelector('.maratona-hero__arrow--next');

    var current = 0;
    var total = slides.length;
    var autoplay = root.dataset.autoplay === 'true';
    var interval = parseInt(root.dataset.autoplayInterval, 10) * 1000 || 6000;
    var timer = null;
    var isHovered = false;

    function goTo(index) {
      if (index < 0) index = total - 1;
      if (index >= total) index = 0;

      slides.forEach(function (slide, i) {
        if (i === index) {
          slide.classList.add('is-active');
          slide.setAttribute('aria-hidden', 'false');
        } else {
          slide.classList.remove('is-active');
          slide.setAttribute('aria-hidden', 'true');
        }
      });

      dots.forEach(function (dot, i) {
        if (i === index) {
          dot.classList.add('is-active');
          dot.setAttribute('aria-selected', 'true');
        } else {
          dot.classList.remove('is-active');
          dot.setAttribute('aria-selected', 'false');
        }
      });

      current = index;
    }

    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }

    function startAutoplay() {
      if (!autoplay || isHovered) return;
      stopAutoplay();
      timer = setInterval(next, interval);
    }

    function stopAutoplay() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    // Click handlers
    if (prevBtn) prevBtn.addEventListener('click', function () {
      prev();
      startAutoplay();
    });
    if (nextBtn) nextBtn.addEventListener('click', function () {
      next();
      startAutoplay();
    });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var idx = parseInt(dot.dataset.targetSlide, 10);
        if (!isNaN(idx)) {
          goTo(idx);
          startAutoplay();
        }
      });
    });

    // Pause on hover
    root.addEventListener('mouseenter', function () {
      isHovered = true;
      stopAutoplay();
    });
    root.addEventListener('mouseleave', function () {
      isHovered = false;
      startAutoplay();
    });

    // Keyboard navigation
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') {
        prev();
        startAutoplay();
      } else if (e.key === 'ArrowRight') {
        next();
        startAutoplay();
      }
    });

    // Touch swipe
    var touchStartX = 0;
    var touchEndX = 0;
    root.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });
    root.addEventListener('touchend', function (e) {
      touchEndX = e.changedTouches[0].screenX;
      var diff = touchStartX - touchEndX;
      if (Math.abs(diff) < 50) return;
      if (diff > 0) {
        next();
      } else {
        prev();
      }
      startAutoplay();
    }, { passive: true });

    // Pause when tab not visible
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        stopAutoplay();
      } else {
        startAutoplay();
      }
    });

    // Respect reduced motion preference
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) {
      autoplay = false;
    }

    // Initial state
    goTo(0);
    startAutoplay();
  }

  function initAll() {
    var sliders = document.querySelectorAll('.maratona-hero');
    sliders.forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init on Shopify section reload (theme editor)
  document.addEventListener('shopify:section:load', function (e) {
    var slider = e.target.querySelector('.maratona-hero');
    if (slider) initSlider(slider);
  });
})();
